import { useQuery } from '@tanstack/react-query';
import { queryConfig } from './queryConfig';

export const useAppQuery = (options) => {
  return useQuery({
    staleTime: queryConfig.staleTime.medium,
    retry: queryConfig.retry.default,
    refetchOnWindowFocus: queryConfig.refetchOnWindowFocus,
    refetchOnMount: queryConfig.refetchOnMount,
    refetchOnReconnect: queryConfig.refetchOnReconnect,
    ...options,
  });
};

